export const a11y = {
    getAddRemoveButtonAriaDescribedBy: (areAllSelected, areItemsDisabled) => `Select this button to ${areAllSelected ? 'remove' : 'add'} all ${areItemsDisabled ? 'enabled ' : ''}items in the select list`,
    getAriaLiveAddRemoveAll: (areAllSelected, areItemsDisabled) => {
        const allItemsPhrase = areItemsDisabled ? 'all enabled items' : 'all items';
        return `${allItemsPhrase} ${areAllSelected ? 'cleared' : 'selected'}`;
    },
};
export const visual = {
    getAddRemoveAllButtonText: (areAllSelected) => areAllSelected ? 'Clear All' : 'Select All',
};
//# sourceMappingURL=strings.js.map